module.exports = __webpack_public_path__ + "img/ic_64_stopclock.dc5c1b1f.svg";